import { render } from "./NotificationSettings.vue?vue&type=template&id=8e3b5c92&scoped=true"
import script from "./NotificationSettings.vue?vue&type=script&lang=js"
export * from "./NotificationSettings.vue?vue&type=script&lang=js"

import "./NotificationSettings.vue?vue&type=style&index=0&id=8e3b5c92&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e3b5c92"]])

export default __exports__